import Edit from "@mui/icons-material/Edit";
import { Box, GridLegacy as Grid, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { xsHeight, mdHeight } from "components/AppBar";
import { tabsOffset } from "components/TabLinks";

import { useFacility } from "../useFacility";
import { V2DisplayOnlyField as DisplayOnlyField } from "./V2DisplayOnlyField";

export const STATE_INFORMATION_SECTION_ID = "state-information";
export const STATE_INFORMATION_SECTION_ICON = "🏛️";

export const StateInformationSection: React.FC = () => {
  const theme = useTheme();
  const { data } = useFacility();
  const facility = data?.facility;
  const isCA = facility?.state === "CA";
  const stateFields = facility?.stateFields ?? [];

  return (
    <Box
      id={STATE_INFORMATION_SECTION_ID}
      sx={{
        scrollMarginTop: {
          xs: theme.spacing(xsHeight + tabsOffset + 11),
          md: theme.spacing(mdHeight + tabsOffset + 11),
        },
        "& .edit-icon": { opacity: 0, transition: "opacity 200ms" },
        "&:hover .edit-icon": { opacity: 1 },
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={5}>
        <Typography variant="h6">
          {STATE_INFORMATION_SECTION_ICON} State Information (Chemicals)
        </Typography>
        <IconButton size="small" className="edit-icon" sx={{ color: "action.selected", mr: 2 }}>
          <Edit />
        </IconButton>
      </Stack>

      {isCA ? (
        <Typography variant="body2" color="text.secondary">
          California HMBP questions appear in the facility's Tier II report in Chemicals.
        </Typography>
      ) : stateFields.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No additional state information needed.
        </Typography>
      ) : (
        <Grid container columnSpacing={3} rowSpacing={2}>
          {stateFields.map((field) => (
            <Grid item xs={12} md={6} key={field.key}>
              <DisplayOnlyField
                label={<span style={{ whiteSpace: "normal" }}>{field.label ?? field.key}</span>}
                text={field.value ?? ""}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};
